import classNames from 'classnames';

export const cn = (...inputs: Parameters<typeof classNames>) => classNames(...inputs);
